import { baseURL } from '@/v2/constants/requests'
import { useQuery } from '@tanstack/react-query'

export const useWeeklyCalendar = ({ from: fromParam, to: toParam }) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['WeeklyCalendar', `${fromParam} - ${toParam}`],
    queryFn: async () => {
      const res = await fetch(
        `${baseURL}/v2/rest/calendars/days?from=${fromParam}&to=${toParam}`
      )
      if (!res.ok) {
        throw new Error("We couldn't load the weekly calendar")
      }
      const result = await res.json()
      return result
    },
    enabled: !!fromParam && !!toParam,
  })

  return { data, isLoading, isError }
}

export const useDailyCalendar = date => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['DailyCalendar', date],
    queryFn: async () => {
      const res = await fetch(
        `${baseURL}/v2/rest/calendars/days?from=${date}&to=${date}`
      )
      if (!res.ok) {
        throw new Error("We couldn't load the daily calendar")
      }
      const result = await res.json()
      return result
    },
    enabled: !!date,
  })

  return { data, isLoading, isError }
}
